import React from 'react';

const Na = () => (
  <span
    style={{
      fontStyle: 'italic',
      opacity: 0.4,
    }}
  >
    n/a
  </span>
);

export default Na;
